export class ApiConfig {
	URL: string
	environment: string
	APIScope: string
	APIScopeURL: string

	constructor( apiURL:string, env:string, APIScope:string,APIScopeURL:string ) {
		this.URL = apiURL;
		this.environment = env;
		this.APIScope= APIScope;
		this.APIScopeURL= APIScopeURL;
	}
};

export class AuthConfig {
	clientId:string; 
	 authority:string;
	 redirectUri:string;
	 postLogoutUri:string;

	constructor( clientId:string, authority:string, redirectUri:string, postLogoutUri:string ) {
		this.clientId = clientId;
		this.authority = authority;
		this.redirectUri = redirectUri;
		this.postLogoutUri = redirectUri;
	}
};


export class AppConfig {
	//>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
	// Stuff tthat is identical to config-variable.json content. Any update in config-variable.json
	// must be propagated below
	IT_LINK:string="";
	FAQ_LINK:string="";
	PRE_PAY_LINK:string="";
	SHAREPOINT_LINK:string="";
	SUPPORT_LINK:string="";
	CHANGE_HOMEBASE_TO_EMAIL:string="";
	CHANGE_HOMEBASE_EMAIL_SUBJECT_EN:string="";
	CHANGE_HOMEBASE_EMAIL_SUBJECT_FR:string="";
	CHANGE_HOMEBASE_EMAIL_BODY_EN:string="";
	CHANGE_HOMEBASE_EMAIL_BODY_FR:string="";
	SERVICE_NOW_LINK:string="";
	
	authConfig: AuthConfig = new AuthConfig("","","","");
	apiConfigs: { [key:string]:ApiConfig} = {};
	//<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

	//>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
	// class enrichment

	private hostname:string="";
	
	constructor( host:string="") { 
		this.hostname = host;
	}

	public get AppHostname():string {
		return this.hostname;
	}

	public get ApiUrl():string|undefined {
		return this.apiConfigs[this.hostname]?.URL;
	}

	public get ApiScope():string {
		return this.apiConfigs[this.hostname].APIScope;
	}

	public get ApiScopeURL():string {
		return this.apiConfigs[this.hostname].APIScopeURL;
	}
	//<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
}
